import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'

export interface OrderPlaylistDto {
  businessName: string
  activityType: string
  address: string

  males: string
  females: string

  age18_30: string
  age31_45: string
  age46_60: string

  vocalToInstrumental: string
  internationalToLocal: string

  extraClarifications: string
  linkTracksExamples: string

  // как в mobile: массив жанров (строки)
  styles: string[]
}

export type Order = OrderPlaylistDto & {
  _id: string
  playlists?: any[]
  createdAt: number
}

export type OrdersState = {
  allOrders: Order[]
  listLoading: boolean
  createLoading: boolean
  error: string | null
}

export const initialState: OrdersState = {
  allOrders: [],
  listLoading: false,
  createLoading: false,
  error: null,
}

export const attemptGetUserOrders = createAsyncThunk<Order[]>(
  'order/user/list',
  async () => {
    const response = await $api.post('order/user/list', {})
    return response.data
  },
)

export const attemptOrderPlayList = createAsyncThunk<string, OrderPlaylistDto>(
  'order/create',
  async (payload) => {
    const response = await $api.post('order/create', payload)
    return response.data
  },
)

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearOrdersError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // list
      .addCase(attemptGetUserOrders.pending, (state) => {
        state.listLoading = true
        state.error = null
      })
      .addCase(attemptGetUserOrders.fulfilled, (state, { payload }) => {
        state.listLoading = false
        state.allOrders = payload ?? []
      })
      .addCase(attemptGetUserOrders.rejected, (state, action) => {
        state.listLoading = false
        state.error = action.error?.message || 'Failed to load orders'
      })

      // create
      .addCase(attemptOrderPlayList.pending, (state) => {
        state.createLoading = true
        state.error = null
      })
      .addCase(attemptOrderPlayList.fulfilled, (state) => {
        state.createLoading = false
      })
      .addCase(attemptOrderPlayList.rejected, (state, action) => {
        state.createLoading = false
        state.error = action.error?.message || 'Failed to create order'
      })
  },
})

export const { clearOrdersError } = ordersSlice.actions
export default ordersSlice.reducer
